import React from 'react'
import { withRouter } from 'router'

import classNames from 'classnames'

import styles from './style.module.scss'

interface EmptyLayoutProps {
  children: React.ReactNode
}

const EmptyLayout: React.FC<EmptyLayoutProps> = ({ children }) => {
  const path = window.location.pathname
  const isThreadViewer = path.indexOf('/plain/threadViewer') === 0

  const clsNames = {
    officemail: isThreadViewer === false,
  }
  return <div className={classNames(styles.EmptyLayout, clsNames)}>{children}</div>
}

export default withRouter(EmptyLayout)
